var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6692 13.6041L36.6692 13.7249C36.6691 15.1595 36.6691 15.8768 36.3238 16.4637C35.9785 17.0505 35.3515 17.3989 34.0974 18.0956L32.7752 18.8301C33.6864 15.7499 33.9903 12.4404 34.1027 9.61012C34.1075 9.48877 34.1129 9.36592 34.1184 9.24177L34.1223 9.15481C35.2077 9.53176 35.8172 9.81279 36.1973 10.3403C36.6692 10.995 36.6692 11.8647 36.6692 13.6041Z",
    fill: "url(#paint0_linear_7915_82076)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 13.6041L3.33594 13.7249C3.33598 15.1595 3.336 15.8768 3.68132 16.4637C4.02663 17.0505 4.65365 17.3989 5.90768 18.0956L7.23062 18.8305C6.31939 15.7502 6.01539 12.4405 5.90302 9.61012C5.8982 9.48877 5.89278 9.36592 5.88729 9.24177L5.88345 9.1546C4.79762 9.53166 4.18803 9.81269 3.80776 10.3403C3.33587 10.995 3.33589 11.8647 3.33594 13.6041Z",
    fill: "url(#paint1_linear_7915_82076)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2978 3.9114C25.4244 3.59531 22.9754 3.3335 20.0029 3.3335C17.0303 3.3335 14.5813 3.59531 12.7079 3.9114C10.81 4.23162 9.86108 4.39172 9.06821 5.36822C8.27535 6.34471 8.31725 7.40012 8.40105 9.51095C8.68875 16.7575 10.2525 25.8086 18.7526 26.6096V32.5002H16.3689C15.5745 32.5002 14.8905 33.0609 14.7346 33.84L14.4193 35.4168H10.0026C9.31225 35.4168 8.7526 35.9765 8.7526 36.6668C8.7526 37.3572 9.31225 37.9168 10.0026 37.9168H30.0026C30.693 37.9168 31.2526 37.3572 31.2526 36.6668C31.2526 35.9765 30.693 35.4168 30.0026 35.4168H25.5859L25.2706 33.84C25.1148 33.0609 24.4307 32.5002 23.6363 32.5002H21.2526V26.6097C29.7531 25.809 31.317 16.7576 31.6047 9.51095C31.6885 7.40012 31.7304 6.34471 30.9375 5.36822C30.1446 4.39172 29.1957 4.23162 27.2978 3.9114Z",
    fill: "url(#paint2_linear_7915_82076)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7915_82076",
    x1: 9.2883,
    y1: 5.49495,
    x2: 33.2426,
    y2: 25.0407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E18937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7915_82076",
    x1: 9.2883,
    y1: 5.49495,
    x2: 33.2426,
    y2: 25.0407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E18937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7915_82076",
    x1: 9.2883,
    y1: 5.49495,
    x2: 33.2426,
    y2: 25.0407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E18937"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.4410795136951612e8c3803d477d0706.svg";
export { ForwardRef as ReactComponent };